import { AutogenModelLateRoute, AutogenRowLateRoute } from "./autogen/AutogenModelLateRoute";

export class ModelLateRoute extends AutogenModelLateRoute<RowLateRoute> {
	constructor() {
		super(RowLateRoute);
	}
}

export class RowLateRoute extends AutogenRowLateRoute {
}
